import type { FC } from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  size = "md",
  className = "",
}) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-16 h-16",
    lg: "w-24 h-24",
  };

  return (
    <img
      src="/images/pwa-loader.svg"
      alt="Laden"
      aria-busy="true"
      className={`block ${sizeClasses[size]} ${className}`}
    />
  );
};
